import { useCallback, useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { getIsBlogListingPage, getIsSitePage, getIsLandingPage } from 'ContentEditorUI/redux/selectors/contentReadOnlyDataSelectors';
import UsageTracker from 'ContentEditorUI/utils/UsageTracker';
const getPageType = (isLandingPage, isSitePage, isBlogListingPage) => {
  if (isLandingPage) {
    return 'landing-page';
  }
  if (isSitePage) {
    return 'site-page';
  }
  if (isBlogListingPage) {
    return 'blog-listing-page';
  }
  return undefined;
};
const usePersonalizationTrackerProps = () => {
  const [trackerProps, setTrackerProps] = useState(undefined);
  const isLandingPage = useSelector(getIsLandingPage);
  const isSitePage = useSelector(getIsSitePage);
  const isBlogListingPage = useSelector(getIsBlogListingPage);
  const pageType = useMemo(() => getPageType(isLandingPage, isSitePage, isBlogListingPage), [isLandingPage, isSitePage, isBlogListingPage]);
  const populateTrackerProps = useCallback(() => {
    if (trackerProps) {
      return;
    }
    const originalTracker = UsageTracker.getTracker();
    const personalizationTracker = originalTracker.clone({
      standalone: true,
      preserveTrackerProperties: true
    });
    setTrackerProps({
      tracker: personalizationTracker,
      appName: 'page-editor-ui',
      screen: `${pageType}-editor`
    });
  }, [pageType, trackerProps]);
  useEffect(() => {
    UsageTracker.subscribe(populateTrackerProps);
  }, [populateTrackerProps]);
  return trackerProps;
};
export default usePersonalizationTrackerProps;